import { formSubmit, loadedModal } from '@hotjar/webapp/tracking/common';
import type { OwnedAccount } from '@hotjar/account';
import { api as paymentMethodApi } from '@hotjar/webapp/billing/paymentMethod';
import { isCardExpiringSoon } from '@hotjar/webapp/domains/billing/paymentMethod';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';

export const BILLING_CYCLE_EVENT = 'Billing Cycle Selector';

export const PAYMENT_METHOD_EVENT = 'Payment Method Selector';

export const SET_PAYMENT_DETAILS = 'Set payment details';

export const PAYMENT_DETAILS = 'Payment details';

export const MODAL_LOADED_REFERRER = {
  updatePlans: 'Plans and Billing: Update Plan',
};

export const PAYMENT_FORM_SUBMITTED_ERRORS = {
  billingCycle: 'Payment Frequency Not Selected',
  agreeNotice: 'Annual billing checkbox not checked',
  billingDetails: 'Invalid card billing details',
  hostedForm: 'Invalid card number, expiration date or CVV',
};

export async function trackPaymentModalLoaded(
  account: OwnedAccount,
  referrer?: string,
): Promise<void> {
  try {
    const { pastDue, expiryDate } = await paymentMethodApi.get(account);

    const data = {
      modal_version: 'v2',
      subscription_past_due: pastDue,
      subscription_card_expiring: isCardExpiringSoon(expiryDate),
      ...(referrer && {
        ui_position: referrer,
      }),
    };

    loadedModal(PAYMENT_DETAILS, extractAccountGroupingProps(account), data);
  } catch {
    /** noop: nothing bad will hapen if this fails so no need to report it */
  }
}

export async function trackPaymentFormSubmitted(
  account: OwnedAccount | undefined,
  submitSuccess: boolean,
  errorMessage?: string,
): Promise<void> {
  formSubmit({
    name: SET_PAYMENT_DETAILS,
    submitSuccess,
    data: {
      ...(errorMessage && {
        app_form_submit_failure_reason: errorMessage,
      }),
    },
    groupData: extractAccountGroupingProps(account),
  });
}
